import { render } from "./LongForm.vue?vue&type=template&id=08f4dcfb&scoped=true"
import script from "./LongForm.vue?vue&type=script&lang=js"
export * from "./LongForm.vue?vue&type=script&lang=js"

import "./LongForm.vue?vue&type=style&index=0&id=08f4dcfb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f4dcfb"]])

export default __exports__